import { useEffect } from 'react'

const PIXEL_ID = '2662963797370196'

let initialized = false

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

function loadPixelScript() {
  if (initialized) return
  initialized = true

  const f = window as any
  const b = document
  const n = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  }) as any
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
  }, [])
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Diccionario del Cabello',
      content_type: 'product',
      value: 6.99,
      currency: 'USD',
    })
  }
}
